import { render, staticRenderFns } from "./fx-transactions.vue?vue&type=template&id=7091b7ae&scoped=true"
import script from "./fx-transactions.vue?vue&type=script&lang=js"
export * from "./fx-transactions.vue?vue&type=script&lang=js"
import style0 from "./fx-transactions.vue?vue&type=style&index=0&id=7091b7ae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091b7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7091b7ae')) {
      api.createRecord('7091b7ae', component.options)
    } else {
      api.reload('7091b7ae', component.options)
    }
    module.hot.accept("./fx-transactions.vue?vue&type=template&id=7091b7ae&scoped=true", function () {
      api.rerender('7091b7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/fx-transactions.vue"
export default component.exports